let config = {
    url: {
        app: "http://127.0.0.1:3000", //主站地址
        developer: "http://127.0.0.1:61113", //开放平台地址
        ws: "ws://192.168.2.155:61117", //websocket地址
        link: "http://192.168.2.155:61112"
    }
}

export { config }